import { getMessages } from '../../../../../../../store/constants';

export const CARD_DATES_BUTTON_CALENDAR = getMessages().getText('card_form_dates_calendar_button');
export const CARD_DATES_BUTTON_CALENDAR_TOOLTIP = getMessages().getText('card_form_dates_calendar_button_tooltip');
